export default "__VITE_ASSET__0f3d24e8__"